<template>
  <statistics-card-line
    hideChart
    :color="colorScoring"
    class="mb-base"
    icon="AwardIcon"
    icon-right
    :statistic="score|fixNumber"
    :statisticTitle="title"/>
</template>

<script>
import {fixNumber} from "@/filters/NumberFilters";

export default {
  name: "RiskModelResult",
  props: {
    title: {
      type: String,
      default: 'Resultado'
    },
    score: {
      type: Number,
      required: true
    },
    highConfig: {
      type: Array,
      required: true
    },
    mediumConfig: {
      type: Array,
      required: true
    },
    lowConfig: {
      type: Array,
      required: true
    }
  },
  computed: {
    colorScoring() {
      this.$emit("input", this.getColorScoring())
      return this.getColorScoring();
    }
  },
  filters: {
    fixNumber
  },
  methods: {
    getColorScoring() {
      if (this.score <= this.lowConfig[1] && this.score > this.lowConfig[0]) {
        return 'danger';
      }
      if (this.score <= this.mediumConfig[1] && this.score > this.mediumConfig[0]) {
        return 'warning'
      }
      if (this.score <= this.highConfig[1] && this.score > this.highConfig[0]) {
        return 'success';
      }
    }
  }
}
</script>

<style scoped>

</style>
